import * as Yup from "yup";
import {
  emailValidationRegex,
  phoneNumberRegex,
  faxNumberRegex,
  websiteUrlRegex,
  zipCodeRegex,
} from "../../../../constants/regexStrings";
import phoneValidation from "../../../../common/components/phone-number-input-component/phone-validation";
import { isOnlyCountryCode } from "../../../../utils/utils";

export const initialValues = {
  company: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  role: "",
  status: "",
};

const FILE_SIZE = 10 * 1024 * 1024;
const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
export const validationSchema = (isEditMode: boolean) =>
  Yup.object().shape({
    company: Yup.string()
      .required("Company cannot be empty")
      .max(150, "Email cannot be more than 150 characters"),
    title: Yup.string().max(50, "Title cannot be more than 50 characters"),
    firstName: Yup.string().required("First Name cannot be empty"),
    lastName: isEditMode
      ? Yup.string()
      : Yup.string().required("Last Name cannot be empty"),
    email: Yup.string()
      .matches(emailValidationRegex, "Please enter a valid Email address")
      .required("Email cannot be empty")
      .max(150, "Email cannot be more than 150 characters"),
    role: Yup.number().required("Role cannot be empty"),
    phoneNumber: Yup.string()
      .test(
        "valid-phone-check",
        "Please enter a valid phone number",
        function (value) {
          if (!value) return false;

          if (isOnlyCountryCode(value)) {
            return this.createError({
              message: "Phone number is required",
            });
          }

          if (!phoneValidation(value)) {
            return this.createError({
              message: "Please enter a valid phone number",
            });
          }

          return true;
        }
      )
  });
